export enum SuccessMessageConstants {
  RECORD_CREATED_SUCCESSFULLY = "Record created successfully.",
  RECORD_UPDATED_SUCCESSFULLY = "Record updated successfully.",
  RECORD_DELETED_SUCCESSFULLY = "Record deleted successfully.",
  USER_UPDATED_SUCCESSFULLY = "User updated successfully.",
  USER_ADDED_SUCCESSFULLY = "User added successfully.",
  LOGOUT_SUCCESS = "Logged out successfully.",
  LOGIN_SUCCESS = "Login successful.",
  FILE_UPLOAD_SUCCESSFUL = "File uploaded successfully."
}
